import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useRef,
  useState,
} from 'react'

interface IScrollControlContextData {
  isScrollingContent: boolean
  setIsScrollingContent: (value: boolean) => void
  scrollToTop: () => void
  registerScrollToTop: (fn: () => void) => void
}

export const ScrollControlContext = createContext<IScrollControlContextData>(
  {} as IScrollControlContextData,
)

interface IScrollControlProviderProps {
  children: ReactNode
}

export function ScrollControlProvider({
  children,
}: IScrollControlProviderProps) {
  const [isScrollingContent, setIsScrollingContent] = useState(false)
  const scrollToTopRef = useRef<(() => void) | null>(null)

  const registerScrollToTop = useCallback((fn: () => void) => {
    scrollToTopRef.current = fn
  }, [])

  const scrollToTop = useCallback(() => {
    scrollToTopRef.current?.()
  }, [])

  const value = useMemo(
    () => ({
      isScrollingContent,
      setIsScrollingContent,
      scrollToTop,
      registerScrollToTop,
    }),
    [
      isScrollingContent,
      setIsScrollingContent,
      scrollToTop,
      registerScrollToTop,
    ],
  )

  return (
    <ScrollControlContext.Provider value={value}>
      {children}
    </ScrollControlContext.Provider>
  )
}
